import dynamic from 'next/dynamic'
import { BlockProps } from '../BlockProps'
import { ISalesManagerBlockData } from './ISalesManagerBlockData'

export const DynamicSalesManagerBlock = dynamic<
  BlockProps<ISalesManagerBlockData>
>(() => import('./SalesManagerBlock').then((md) => md.SalesManagerBlock))
